import { createSlice, nanoid } from "@reduxjs/toolkit";

const initialState = {
  projects: [
    {
      id: "p1",
      name: "Project Management App",
      description: "Internal tool to manage projects, boards and tasks.",
    },
    {
      id: "p2",
      name: "Website Redesign",
      description: "Update marketing website with new branding.",
    },
  ],
  selectedProjectId: "p1",
};

const projectsSlice = createSlice({
  name: "projects",
  initialState,
  reducers: {
    addProject: {
      reducer(state, action) {
        state.projects.push(action.payload);
      },
      prepare(project) {
        return { payload: { id: nanoid(), ...project } };
      },
    },
    updateProject(state, action) {
      const { id, updates } = action.payload;
      const index = state.projects.findIndex((p) => p.id === id);
      if (index !== -1) {
        state.projects[index] = { ...state.projects[index], ...updates };
      }
    },
    deleteProject(state, action) {
      const id = action.payload;
      state.projects = state.projects.filter((p) => p.id !== id);
      if (state.selectedProjectId === id) {
        state.selectedProjectId = state.projects[0]?.id || null;
      }
    },
    selectProject(state, action) {
      state.selectedProjectId = action.payload;
    },
  },
});

export const {
  addProject,
  updateProject,
  deleteProject,
  selectProject,
} = projectsSlice.actions;

export default projectsSlice.reducer;
